import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

const ChannelRoute = () => <Outlet />;

export const Route = createFileRoute(
  "/study-group/$study-group-id/channel/$channel-id",
)({
  beforeLoad: ({ location, params }) => {
    if (/\/channel\/[^/]+$/.test(location.pathname)) {
      if (params["channel-id"] === "home") {
        throw redirect({
          to: "/study-group/$study-group-id/stream",
          params: { "study-group-id": params["study-group-id"] },
          replace: true,
        });
      }
      throw redirect({
        to: "/study-group/$study-group-id/stream/channel/$channel-id",
        params: {
          "study-group-id": params["study-group-id"],
          "channel-id": params["channel-id"],
        },
        replace: true,
      });
    }
  },
  component: ChannelRoute,
});
